import AppIcon from "@/common/components/Icons/AppIcon";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { LocationDto, LocationReferenceDto } from "@/core/api/generated/v1";

import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";
import { getLocationOptionTitle } from "./LocationAutocomplete";

export interface LocationInlineProps extends BaseEntityInlineInheritableProps {
  entity?: LocationDto | LocationReferenceDto | null | undefined;
  entityId?: string | null;
}

/** Inline brief information about the entity. */
export default function LocationInline({ entity, entityId, ...otherProps }: LocationInlineProps) {
  const request = useApiRequest(
    apiClient.locationsApi.apiV1LocationsLocationIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      locationId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity,
    },
  );
  // fallback to ref if don't have access to full entity
  const refRequest = useApiRequest(
    apiClient.locationsApi.apiV1LocationsLocationIdReferenceGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      locationId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity || (request.isLoading && !request.isEnded),
    },
  );
  entity = request?.data || entity || refRequest?.data;

  const full = entity as LocationDto;
  // const ref = entity as LocationReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      request={request.data ? request : refRequest}
      icon={<AppIcon of='location' inText />}
      content={<>{full && getLocationOptionTitle(full)}</>}
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Department"}
    />
  );
}
